export default {
  telegram: 'https://t.me/SGroup_ru',
  facebook: 'https://www.facebook.com/SGroup.io.ru',
  instagram: 'https://www.instagram.com/SGroup_ru/',
  youtube: 'https://www.youtube.com/c/SGroup_io',
}